export default __webpack_public_path__ + "static/media/Background_00120.bca2c04b.png";